<div class="dynamic-form">
    <div class="step-wrapper">
        <div class="modal-body">
            <cm-dynamic-form-content-details [contentDetails]="modalDetails"></cm-dynamic-form-content-details>
            <div class="tabset">
                <ul
                    ngbNav
                    #nav="ngbNav"
                    [class.interactive-tab-set]="isStepSubmitted"
                    (navChange)="onTabChange($event)"
                    [destroyOnHide]="false"
                    [activeId]="activeTabId"
                    class="nav-tabs nav-justified"
                >
                    <li
                        *ngFor="let tab of tabs"
                        [domId]="tab.id.toString()"
                        ngbNavItem
                        (shown)="showTabElements(tab.id)"
                        [disabled]="tab.disabled"
                    >
                        <a ngbNavLink>{{ tab.title }}</a>
                        <ng-template ngbNavContent>
                            <p
                                class="mt-4 bold"
                                *ngIf="tab.id === ONBOARDING_TAB_ID.JURISDICTION_INFORMATION && !isStepSubmitted"
                            >
                                Please provide the country(ies) and state(s) where you provide services
                                <i
                                    class="fa fa-question-circle"
                                    container="body"
                                    tooltipClass="max-400 text-left"
                                    [ngbTooltip]="jurisdictionTabTitle"
                                ></i>
                            </p>
                            <ng-container [ngSwitch]="tab.type">
                                <ng-container *ngSwitchCase="ONBOARDING_TAB_TYPES.FORM_GROUP">
                                    <div
                                        *ngFor="let form of tab.forms"
                                        [hidden]="
                                            tab.id === ONBOARDING_TAB_ID.JURISDICTION_INFORMATION && form.isNational
                                        "
                                    >
                                        <ng-container
                                            *ngIf="
                                                [
                                                    ONBOARDING_TAB_ID.LICENSE_INFORMATION,
                                                    ONBOARDING_TAB_ID.JURISDICTION_INFORMATION
                                                ].includes(tab.id) && step.content.allowMultipleEntries
                                            "
                                        >
                                            <h4 class="license_information_title mt-4">
                                                <ng-container
                                                    *ngIf="
                                                        tab.id === ONBOARDING_TAB_ID.LICENSE_INFORMATION;
                                                        else jurisdictionTmpl
                                                    "
                                                >
                                                    {{ step.specialization_label }}
                                                </ng-container>
                                                #{{ getRecordIndex(tab, form) }}
                                                <span class="ml-1" *ngIf="form.isNational">(National Credential)</span>
                                            </h4>
                                            <div
                                                class="text-center"
                                                *ngIf="tab.forms.length > 1 && !isStepSubmitted && !form.required"
                                            >
                                                <button
                                                    class="btn btn-default btn-action remove-btn pl-1"
                                                    (click)="removeForm(tab.id, form.dynamicFormInstanceId)"
                                                >
                                                    <i class="fa fa-trash"></i> Remove
                                                    <ng-container
                                                        *ngIf="
                                                            tab.id === ONBOARDING_TAB_ID.LICENSE_INFORMATION;
                                                            else jurisdictionTmpl
                                                        "
                                                    >
                                                        {{ step.specialization_label }}
                                                    </ng-container>
                                                </button>
                                            </div>
                                        </ng-container>
                                        <cm-dynamic-form
                                            [ngClass]="{ 'mt-4': tab.forms.length === 1 }"
                                            [formId]="form.dynamicFormInstanceId"
                                            class="submit-form tab mt-2"
                                            [elements]="form.fields"
                                            [disabled]="isStepSubmitted"
                                            [showErrors]="showErrors"
                                            [sections]="tab.sections"
                                            [showAllCustomErrors]="true"
                                            (updateFieldValue)="updateFieldValue($event, tab.id, form)"
                                        >
                                        </cm-dynamic-form>
                                        <hr
                                            *ngIf="
                                                tab.id === ONBOARDING_TAB_ID.LICENSE_INFORMATION &&
                                                step.content.allowMultipleEntries &&
                                                (!isStepSubmitted || !lastOfVisible(tab, form))
                                            "
                                        />
                                    </div>
                                    <div
                                        class="text-center"
                                        *ngIf="
                                            !isStepSubmitted &&
                                            [
                                                ONBOARDING_TAB_ID.LICENSE_INFORMATION,
                                                ONBOARDING_TAB_ID.JURISDICTION_INFORMATION
                                            ].includes(tab.id) &&
                                            step.content.allowMultipleEntries
                                        "
                                    >
                                        <button
                                            class="btn btn-default btn-action mt-2"
                                            (click)="addAnotherForm(tab.id)"
                                        >
                                            + Add
                                            <ng-container
                                                *ngIf="
                                                    tab.id === ONBOARDING_TAB_ID.LICENSE_INFORMATION;
                                                    else jurisdictionTmpl
                                                "
                                            >
                                                another {{ step.specialization_label }}
                                            </ng-container>
                                        </button>
                                    </div>
                                    <div
                                        class="text-center"
                                        *ngIf="
                                            !isStepSubmitted &&
                                            tab.id === ONBOARDING_TAB_ID.LICENSE_INFORMATION &&
                                            step.content.allowMultipleEntries
                                        "
                                    >
                                        <button
                                            class="btn btn-default btn-action"
                                            *ngIf="showAddNationalLink"
                                            (click)="addAnotherForm(tab.id, { isNational: true })"
                                        >
                                            + Add National Credential
                                            <i
                                                class="fa fa-question-circle ml-1"
                                                container="body"
                                                [ngbTooltip]="addNationalCredentialTooltip"
                                            ></i>
                                        </button>
                                    </div>
                                </ng-container>
                                <div class="signature-container" *ngSwitchCase="ONBOARDING_TAB_TYPES.SIGNATURE">
                                    <cm-signature
                                        #signature
                                        *ngIf="
                                            (showSignature$ | async) &&
                                            (formInfo?.signature_required ||
                                                (isStepSubmitted && step.content.signature_link))
                                        "
                                        class="signature-bar"
                                        [class.signature-bar--full]="!isStepSubmitted"
                                        [editable]="!isStepSubmitted"
                                    ></cm-signature>
                                </div>
                            </ng-container>
                        </ng-template>
                    </li>
                </ul>

                <div [ngbNavOutlet]="nav" class="mt-2"></div>
            </div>
            <cm-inline-error class="error-block" [errorMessages]="formErrors" *ngIf="showErrors"></cm-inline-error>
        </div>
        <div class="modal-footer" [class.submitted]="isStepSubmitted">
            <button type="button" class="btn btn-default" (click)="closeModal()">CLOSE</button>
            <div class="action-btn-block" *ngIf="!isStepSubmitted">
                <button *ngIf="!isFirstTab" type="button" class="btn btn-default" (click)="back()">BACK</button>
                <button type="button" class="btn btn-primary" (click)="submit(true)">SAVE AS DRAFT</button>
                <button *ngIf="!isLastTab" type="button" class="btn btn-primary" (click)="nextTab()">NEXT</button>
                <button *ngIf="isLastTab" type="button" class="btn btn-primary" (click)="submit()">SUBMIT</button>
            </div>
        </div>
    </div>
</div>
<ng-template #submitMessage>
    <div class="modal-body confirmation-modal_body">
        Please confirm you would like to submit the information. Once you do so, you may not go back and edit.<br /><br />
        Step name: <span class="bold">{{ step.name }}</span> <br />
        Step type: <span class="bold">{{ STEP_TYPES_NAMES[STEP_TYPES.ONBOARDING] }}</span>
    </div>
</ng-template>
<ng-template #jurisdictionTmpl> Country/State </ng-template>
<ng-template #jurisdictionNextScreenNotification>
    <div class="modal-body">
        {{ jurisdictionNextScreenNotificationText }}
        <div class="mt-4">{{ jurisdictionNextScreenNationalNotificationText }}</div>
    </div>
</ng-template>
